import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTwitter, FaDiscord } from 'react-icons/fa';

const ConnectSection = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      Icon: FaFacebookF,
      link: 'https://www.facebook.com/nkenneapp'
    },
    {
      name: 'Linkedin',
      Icon: FaLinkedinIn,
      link: 'https://www.linkedin.com/company/nkenneai'
    },
    {
      name: 'Instagram',
      Icon: FaInstagram,
      link: 'https://www.instagram.com/nkenneapp'
    },
    {
      name: 'Twitter',
      Icon: FaTwitter,
      link: 'https://twitter.com/NKENNEapp'
    },
    {
      name: 'Discord',
      Icon: FaDiscord,
      link: 'https://discord.gg/9qVN3JjqgX'
    }
  ];

  return (
    <div className="flex flex-col min-w-[152px] md:min-w-[128px] border-l border-white">
      {/* Left border line */}
      <div className=" h-full absolute"></div>

      <div className="pl-6">
        {/* Connect heading */}
        <h2 className="text-2xl font-black mb-6 text-white font-['Axiforma']">
          Connect
        </h2>

        {/* Social links */}
        <div className="flex flex-col gap-4">
          {socialLinks.map((social, index) => (
            <Link
              target='_blank'
              key={index}
              to={social.link}
              className="flex items-center gap-2 group"
            >
              <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center border border-[#1e6c56] group-hover:bg-[#1e6c56] transition-colors">
                <social.Icon className="w-3 h-3 text-[#1e6c56] group-hover:text-white transition-colors" />
              </div>
              <span className="text-white text-base font-normal hover:underline">
                {social.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConnectSection;

